const timeDate = require('../../../../../js-handler/time-date')

export function organizeRowEntityChange(data) {
  return data.map(change => {
    const avatar = change.avatar || 'css/img/pic/person.svg'
    const parsedChanges = JSON.parse(change.changes)
    const inputs = Array.isArray(parsedChanges.input) ? parsedChanges.input : []
    const multiTables = Array.isArray(parsedChanges.mt) ? parsedChanges.mt : []

    const inputRows = inputs.map(input => {
      const previousValue = input.elemId === 'saleDeleted_form_notes' && String(input.from).length > 30
        ? 'Change notes'
        : input.from

      return `<div class="row">
        <div class="c33">${input.elemId}</div>
        <div class="c33">${previousValue}</div>
        <div class="c33">${input.to}</div>
      </div>`
    }).join('')

    const multiTableRows = multiTables.map(table => table.from.map((from, index) => {
      const to = table.to?.[index]
      const toRow = to
        ? `<div class="row">
            <div class="c16">To</div>
            <div class="c16">${to.id}</div>
            <div class="c16">${to.selling_type}</div>
            <div class="c16">${to.qty}</div>
            <div class="c16">$${to.price}</div>
            <div class="c16">$${to.total}</div>
          </div>`
        : ''

      return `<div class="row">
        <div class="c16">From</div>
        <div class="c16">${from.id}</div>
        <div class="c16">${from.selling_type}</div>
        <div class="c16">${from.qty}</div>
        <div class="c16">$${from.price}</div>
        <div class="c16">$${from.total}</div>
      </div>${toRow}`
    }).join('')).join('')

    const multiTableSection = multiTableRows
      ? `<entry>
          <div class="row mt-8">
            <div class="c16">Status</div>
            <div class="c16">Items</div>
            <div class="c16">Units</div>
            <div class="c16">Qty</div>
            <div class="c16">Unit Price</div>
            <div class="c16">Total</div>
          </div>
          ${multiTableRows}
        </entry>`
      : ''

    return `<cont>
      <user>
        <photo class="photo" style="background-image: url('${avatar}')"></photo>
        <title>${change.user_name.trim()}</title>
        <time>${timeDate.friendlyDate(change.date_change)} | ${timeDate.friendlyTime(change.date_change.substring(10))}</time>
      </user>
      <entry>
        <div class="row">
          <div class="c33">Data</div>
          <div class="c33">From</div>
          <div class="c33">To</div>
        </div>
        ${inputRows}
      </entry>
      ${multiTableSection}
    </cont>`
  }).join('')
}
